import { render, staticRenderFns } from "./DeliveryAreaFeeList.vue?vue&type=template&id=7797c932&"
import script from "./DeliveryAreaFeeList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAreaFeeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports